import { render, staticRenderFns } from "./AssignedSiteItem.vue?vue&type=template&id=07f8ba02&"
import script from "./AssignedSiteItem.vue?vue&type=script&lang=js&"
export * from "./AssignedSiteItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports